import { LoadingIcon as LoadingDs } from "@packages/ds";
import styled from "styled-components";

import { ButtonWrapper as DsButtonWrapper } from "ds/Button";
import DsTextarea from "ds/Textarea";

export const Textarea = styled(DsTextarea)`
  max-width: 400px;
`;

export const ButtonWrapper = styled(DsButtonWrapper)`
  margin-top: 2rem;
`;

export const Layout = styled.div`
  display: flex;
  flex-shrink: 0;
  margin: 0;
`;

export const CertificateFormLayout = styled.form`
  box-sizing: border-box;
  width: 100%;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  button,
  a {
    width: max-content;
    margin: 0;
  }
`;

export const Header = styled.h2`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`;

export const Loading = styled(LoadingDs)`
  display: block;
  margin-top: 50px;
`;
